import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../app/hooks';

import { isAdmin } from '../../../utils/userPermissions';

export const useIsAdmin = () => {
  const [isAdminStatus, setIsAdminStatus] = useState(false);
  const { user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!user) setIsAdminStatus(false);
    else setIsAdminStatus(isAdmin(user.role));
  }, [user]);

  return isAdminStatus;
};
